<template>
  <div class="top-bar">
    <a-row type="flex" align="middle" :gutter="[12, 0]">
      <a-col>
        <a-row type="flex" justify="end" align="middle" :gutter="[12, 0]">
          <a-col v-if="$store.state.isNewResident" @click="goResident">
            <a-badge status="error" text="有新业主待审核" />
          </a-col>
          <a-col v-if="$store.state.isNewRepair" @click="goRepair">
            <a-badge status="error" text="有新报修待处理" />
          </a-col>
          <a-col v-if="$store.state.community" @click="changeCommunity">
            <a-space>{{$store.state.community.name}}<a-icon type="swap"></a-icon></a-space>
          </a-col>
          <a-col v-if="$store.state.userInfo">您好，{{$store.state.userInfo.name}}</a-col>
          <a-col><a-icon type="logout" @click="logout"></a-icon></a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-modal :title="modal.title" :footer="null" v-model="modal.show" destroy-on-close centered>
      <choose-community @selected="selectedCommunity" layer></choose-community>
    </a-modal>
  </div>
</template>

<script>
  import ChooseCommunity from '@/views/common/ChooseCommunity.vue';

  export default {
    name: 'TopBar',
    data() {
      return {
        modal: {
          show: false,
          title: '选择社区'
        }
      }
    },
    components: {
      ChooseCommunity,
    },
    mounted () {
      this.$store.dispatch('isNewResident');
      this.$store.dispatch('isNewRepair');
    },
    methods: {
      goResident() {
        this.$router.push({
          name: 'ResidentManage'
        });
      },
      goRepair() {
        this.$router.push({
          name: 'RepairOrder'
        });
      },
      changeCommunity() {
        this.modal.show = true;
      },
      selectedCommunity() {
        window.location.reload();
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .top-bar {
    padding: 0 @padding-lg;
    & > .ant-row-flex {
      & > .ant-col {
        &:last-of-type {
          flex: 1;
          .anticon-logout {
            cursor: pointer;
            font-size: @font-size-lg;
          }
        }
      }
    }
  }
</style>